<template>
  <div>
    <titulo-btns :title="$t('PESSOAS.ENDERECO') + '*'" class="mt-4 ajuste-titulo">
      <b-button
        variant="primary"
        @click="criar"
        >{{ $t('PESSOAS.NOVO_ENDERECO') }}</b-button
      >
    </titulo-btns>
    <div class="ajuste-check">
      <input-checkbox
        v-model="form.mesmoEnderecoResponsavelFinanceiro"
        :label="$t('PESSOAS.ENDERECO_MESMO_ENDERECO')"
      />
    </div>
  </div>
</template>
<script>
import TituloBtns from '@/components/headers/TituloBtns.vue';
import InputCheckbox from '@/components/inputs/InputCheckbox.vue';

export default {
  props: {
    form: { type: Object, default: () => {} }
  },
  components: { TituloBtns, InputCheckbox },
  data() {
    return {
      EnderecoResponsavel: false,
    }
  },
  methods: {
    criar() {
      this.$emit('criar');
    },
  },
};
</script>
<style scoped>
.ajuste-titulo {
  margin-bottom: 0px !important; 
}
.ajuste-check{
  margin-bottom: 20px;
}
</style>
